<template>
  <div>
    <div id="top-main">
      <div class="mycontainer-main">
        <div class="ribbon">
          <div class="ribbon__side--left">
            <span></span></div><div class="ribbon__side--title"><span class="cond caps titile-pizza-mobile">{{$t('vouchers')}}</span></div><div class="ribbon__side--right"><span></span></div><div class="ribbon__shadow"><span></span>
        </div>
        </div>
        <div v-for="(item) in items"
           :key="genUniqueKey(item)">
        <div class="clearfix"></div>
        <h2 v-if="item.single_type && item.single_type.hasOwnProperty('is_default') && !item.single_type.is_default"
            class="watermark desktop cond caps xs-my-20 xs-mx-10 xs-text-center heading-hr"
            :id="encodeSingleName(item.single_type.name)">
          <img v-if="item.single_type.image && item.single_type.image.banner"
               :src="item.single_type.image.banner"/>
          <span class="fs-30 pr-7" v-else>{{item.single_type.name}} </span>
        </h2>
        <div v-if="item.single_type && item.single_type.hasOwnProperty('is_default') && !item.single_type.is_default"
             class="watermark mobile cond caps xs-my-20 xs-mx-10 xs-text-center">
          <img v-if="item.single_type.image && item.single_type.image.banner"
               :src="item.single_type.image.banner"/>
          <p class="fs-30 pr-7 pb-0" v-else>{{item.single_type.name}} </p>
        </div>
        <div class="main-content list-item-menu">
            <item-menu-one-tap v-for="menu in item.singles" v-bind:item="menu" v-bind:cols="2" :key="genUniqueKey(menu)"></item-menu-one-tap>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import $const from '../constants'
  export default {
    name: 'Vouchers.vue',
    components: {
      ItemMenu: () => import('@/components/menu/Item.vue'),
      Cart: () => import('../components/partials/Cart.vue'),
      ItemMenuOneTap: () => import('@/components/menu/ItemOneTap.vue')
    },
    data() {
      return {
        items: [],
        outletCodeVoucher: '',
        categoryUUID: ''
      }
    },
    created() {
      let vm = this
      if( !vm.$session.get('vouchers')) {
        vm.removeDispositionAndCart(vm)
        vm.$session.set('vouchers', true)
        vm.$cart.init(vm)
      }
    },
    mounted() {
      var vm = this
      this.eventTrackingScreenLoad(this, {screen: {'name': 'vouchers.list', 'type': 'vouchers'}})
      vm.axios.getConfigFromTenant({manual: '1'}, function (response) {
        let _config = response.data.data.item
        if (!vm.empty(_config) && _config.voucher_outlet_code && (_config.voucher_outlet_code != "" || _config.voucher_outlet_code != "0") 
            && _config.voucher_category_id && (_config.voucher_category_id != "" || _config.voucher_category_id != "0")) {
          vm.outletCodeVoucher = _config.voucher_outlet_code
          vm.categoryUUID = _config.voucher_category_id
          vm.checkValidOutlet()
        } else {
          vm.$router.push('/')
        }
      })
    },
    methods: {
      initData() {
        let vm = this
        let orderTime = this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''), this.$disposition.getByKey(this, 'collectionTimeValue', ''))
        if (!orderTime) {
          orderTime = moment().utc().format('YYYY-MM-DD HH:mm:ss')
        }
        vm.items = []

        let categoryId = vm.categoryUUID

        let data = vm.getMenuRequest(categoryId)
        data.single_type = 1
        data.order_type = "D"
        data.outlet_code = vm.outletCodeVoucher
        data.tier = 1

        vm.axios.getMenuByCategory(data, function (response) {
          let items = response.data.data.items;
          if (!items || !items.length) {
            items = []
            items.push({
              singles: []
            });
          }

          vm.items = items;

          // Add data for cart item
          vm.$cart.tier = data.tier
          vm.$cart.order_type = data.order_type
          vm.$cart.category_id = data.category_id
          // // Add data for cart item
          // vm.eventTrackingProductLoad(vm, vm.items, false, true)
        })
      },
      encodeSingleName(value) {
        let code = ''
        switch (value) {
          case this.$const.SINGLE_TYPE_NAME.BIG_NEWYORKER_RANGE.VAL:
            code = this.$const.SINGLE_TYPE_NAME.BIG_NEWYORKER_RANGE.KEY
            break
          case this.$const.SINGLE_TYPE_NAME.DELUXE.VAL:
            code = this.$const.SINGLE_TYPE_NAME.DELUXE.KEY
            break
          case this.$const.SINGLE_TYPE_NAME.FAVOURITES.VAL:
            code = this.$const.SINGLE_TYPE_NAME.FAVOURITES.KEY
            break
          case this.$const.SINGLE_TYPE_NAME.CLASSIC.VAL:
            code = this.$const.SINGLE_TYPE_NAME.CLASSIC.KEY
            break
          case this.$const.SINGLE_TYPE_NAME.REGULAR.VAL:
            code = this.$const.SINGLE_TYPE_NAME.REGULAR.KEY
            break
          default:
            break
        }

        return code
      },
      checkValidOutlet () {
        // check time outlet
        var vm = this
        
        let data = {
          orderType: vm.$const.DELIVERY,
          order_time: this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''), this.$disposition.getByKey(this, 'collectionTimeText', '')),
          advance_order: this.$disposition.getByKey(this, 'advanceOrder', 0) || 0,
          outlet_code: vm.outletCodeVoucher,
        }
        this.axios.apiOutlet.getOutletDetail(data,
          function (response) {
            response = response.data
            
            if (response.status) {
              let data = vm.$disposition.get(vm)
              response = response.data.item
              // set data
              data.prefectureName = ''
              data.cityName = ''
              data.villeageName = ''
              data.st = ''
              data.lat = response.lat
              data.long = response.long
              data.postalCode = response.zip_code
              // if (vm.orderType == vm.$const.DELIVERY) {
              //   data.locationName = vm.searchAutoComplete
              //   data.prefectureName = vm.deliveryInfo.state || ''
              //   data.cityName = vm.deliveryInfo.city || ''
              //   data.villeageName = vm.deliveryInfo.streetName || ''
              //   data.st = vm.deliveryInfo.streetNumber || ''
              // } else {
              //   data.locationName = vm.result.locationName
              // }
              
              data.minCart = response.min_cart
              data.outletAddress = response.address
              data.orderType = vm.$const.DELIVERY
              data.outletId = response.id
              data.outletName = response.name
              data.outletCode = response.code
              data.advanceOrder = vm.$disposition.getByKey(vm, 'advanceOrder', 0) || 0
              data.tier = response.tier
              data.takeaWayLess = 0
              vm.$disposition.set(vm, data)
              
              vm.initData()
            } else if (response.message && response.message != '') {
              vm.$notify({
                type: 'warn',
                title: response.message
              })
            }
          },
        )

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Vouchers.vue